import core from '@gin-betting/core';

import moduleLocator from 'moduleLocator';

const {
    hocs: { withAsyncLoad },
    utils: { measureTime },
} = core;

// eslint-disable-next-line
export function loadOutrightModule() {
    return import(/* webpackChunkName: "outright-module" */ './index').then(
        outrightModule => {
            measureTime('outrightModuleLoaded');
            moduleLocator.set('outright', outrightModule);

            return outrightModule;
        }
    );
}

export const AsyncOutrightsList = withAsyncLoad({
    loader: loadOutrightModule,
    loading: function AsyncOutrightLoading() {
        return null;
    },
    componentToRender: 'OutrightsList',
});

export const AsyncOutright = withAsyncLoad({
    loader: loadOutrightModule,
    loading: function AsyncOutrightLoading() {
        return null;
    },
    componentToRender: 'Outright',
});

export const AsyncOutrightPage = withAsyncLoad({
    loader: loadOutrightModule,
    loading: function AsyncOutrightLoading() {
        return null;
    },
    componentToRender: 'OutrightPage',
});

export const AsyncOutrightsBanners = withAsyncLoad({
    loader: loadOutrightModule,
    loading: function AsyncOutrightLoading() {
        return null;
    },
    componentToRender: 'OutrightsBanners',
});
